export default {
	nav: {
		logo: 'CC',
		links: [
			{ text: 'Work', to: 'mywork' },
			{ text: 'About', to: 'mycontact' },
		],
	},
	// gal: {
	// 	img: 'https://images.unsplash.com/photo-1555952517-2e8e729e0b44?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1300&q=80',
	// },
	header: {
		img: 'https://images.unsplash.com/photo-1555952517-2e8e729e0b44?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1300&q=80',
		imgPlaceholder:
			'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/4gIcSUNDX1BST0ZJTEUAAQEAAAIMbGNtcwIQAABtbnRyUkdCIFhZWiAH3AABABkAAwApADlhY3NwQVBQTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9tYAAQAAAADTLWxjbXMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApkZXNjAAAA/AAAAF5jcHJ0AAABXAAAAAt3dHB0AAABaAAAABRia3B0AAABfAAAABRyWFlaAAABkAAAABRnWFlaAAABpAAAABRiWFlaAAABuAAAABRyVFJDAAABzAAAAEBnVFJDAAABzAAAAEBiVFJDAAABzAAAAEBkZXNjAAAAAAAAAANjMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB0ZXh0AAAAAElYAABYWVogAAAAAAAA9tYAAQAAAADTLVhZWiAAAAAAAAADFgAAAzMAAAKkWFlaIAAAAAAAAG+iAAA49QAAA5BYWVogAAAAAAAAYpkAALeFAAAY2lhZWiAAAAAAAAAkoAAAD4QAALbPY3VydgAAAAAAAAAaAAAAywHJA2MFkghrC/YQPxVRGzQh8SmQMhg7kkYFUXdd7WtwegWJsZp8rGm/fdPD6TD////bAEMAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/bAEMBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIABkAGQMBIgACEQEDEQH/xAAbAAABBAMAAAAAAAAAAAAAAAAHAgUGCQMECv/EAC4QAAICAQIEAgkFAAAAAAAAAAIDAQQFBhEABxITFCEIFRYiMVKx0fAyQ1GBkf/EABkBAAIDAQAAAAAAAAAAAAAAAAAHAQIDBP/EACURAQACAgEDAwUBAAAAAAAAAAECAwQRMQASIQUTYRQiI0Fxgf/aAAwDAQACEQMRAD8A4u0pbYapCFm1zmApSgGSNjGFAgADG8kRFMCMR5zMxwf63o+82cVg8dq3PctNX4rSbrO1rVBYx12lWRuMS469Q2mKkwUdzqTJFYYCSJc+7Ma5D43RuW5r6Op6/wBYp0FpMsgxmV1S7GNzHq7tVXnj4Vj1IsS5j8p4JRSxcpVXl7GTED53jZHKa50bypt6T5n809N8ztC2tGk6PZjS1rQ2ZxdGU2rGPsWr9BOIVXBD1ItDjr1DKW710SYu89Fzw3DahjEsPMypMkorh7carcfvLHIx65WZFMrfqY45XcxrnCnttue2Nv4Lo9Kamxn6n6ZgRIx+svtL7cinMKSiGHmX114mRDFlh2Zk78Ubq7MuueNiRlOdS5eJNoh1SnI4oQp2aLkKsiR0n2BBFhi1mYs8QgOqUvkegir9whRBdsSbt3JgPUf4U/bgscwsXjKOPwt8s3ey2cysJv2l2jiDqDYqdy3SsVfOzWdUedaAtPkQyY2CbWWoENARPuHyl/p8chvRv9gnPCCPnnZpE8aTra6JCyUQ0CmtxdIon2uhERORE+etnF3n4vIUsigFm2nZVZAWrU0ClRRPSa3rcohONxmDUcbTMwO8RPBNzXOLWWZXbxtXIMwWAsjaWGncc5kYeom4Szs1qVU9wrrc9fiDgB3F7GsTCBYQyKeMf7n58vESieZfvt7Xy+Ykiek4TujF0nIPIdELbIhAkkSz3Inj7bGLWzi67oya5SgsU3GTF2KLvk7k2QrDO3cUrpYyZkiZJe9uZfEyH4RJdRREREzPDR3T/n6/fhU/qH+/pwrgiaifw18GuOq2O5r/AD/fl6//2Q==',
		text: ['Hi!', "It's me Tiasha.", 'I am a '],
		typical: ['Software Engineer. 🖥', 2000, 'Mobile-App Developer. 🖥', 2000, 'Frontend Developer. 🖥', 2000],
		btnText: 'Know More',
	},
	work: {
		title: 'Projects',

		works: [
			{
				img: process.env.PUBLIC_URL + '/assets/Capture1-removebg-preview.png',

				imgPlaceholder: process.env.PUBLIC_URL + '/assets/Capture1-removebg-preview.png',
					
				projectName: 'NextJs-Blog',
				desc: 'With this application, one can view articles of others and also one can comment on articles of others. If you want to publish your own blog or article, you have to signup and login first, then click on create blog to create your own artcile. Its both web and mobile responsive.',
				technologies: 'ReactJs, Javascript, NextJs, Hooks, Firebase, CSS3, Material-ui',
				site: 'https://blognext-delta.vercel.app/',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/geo.png',

				imgPlaceholder:  process.env.PUBLIC_URL + '/assets/geo.png',

					
				projectName: 'Geocast-Based Messaging app with Location-Tagging facility',
				desc: 'The app mainly facilitates sending and receiving real-time notification messages to nearby users in any emergency situations. Google Map has been integrated for seamless communication between end-users. The end users can add markers on the map(on-touch) and write any reviews or posts about any particular place. Eventually, they can broadcast or unicast the message to any users within a certain range. Very helpful for Army Personnel and Covid specially as they can notify about any nearby threats or location of any covid patients respectively in no time. Successfully deployed the end-to-end application for advantage of end users. You have to install the apk on your phone to view/run this app.',
				technologies: 'AndroidStudio, Java, Firebase(FCM), PHP, MYSQL',
				site: 'https://drive.google.com/file/d/1I0aYnSCbrx6HilI_p-mJ3D0kB9ms0Wug/view?usp=sharing',
			},

		

			{
				img: process.env.PUBLIC_URL + '/assets/Capture4-removebg-preview.png',

				imgPlaceholder: process.env.PUBLIC_URL + '/assets/Capture4-removebg-preview.png',
				
				projectName: 'Ecommerce-Redux',
				desc: 'Shopping app built with redux and react. One can add item to cart, view cart items, view items individually, adjust item quantity, add or delete items and finally checkout their cart items. Integrated with stripe as a payment option with card. Its both web and mobile responsive.',
				technologies: 'ReactJs, Javascript, Redux, Hooks, Stripe, TailwindCSS',
				site: 'https://reactredux-ecomm.netlify.app/#/',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/Capture12-removebg-preview.png',

				imgPlaceholder: process.env.PUBLIC_URL + '/assets/Capture12-removebg-preview.png',
				
				projectName: 'Job-Portal',
				desc: 'A platform to hire and find verified jobs. The job portal of Med-piper is a naukri type of application where you have medicine practitioners and hospitals. Hospitals can post for job openings and the practitioners can apply for the same. Its a desktop application.',
				technologies: 'ReactJs, Sass, Javascript, Redux, Hooks, Material-Ui',
				site: 'https://www.medpiper.com/',
			},

			{
				img: process.env.PUBLIC_URL + '/assets/Capture5-removebg-preview.png',

				imgPlaceholder:  process.env.PUBLIC_URL + '/assets/Capture5-removebg-preview.png',
				
				projectName: 'CryptoMarket',
				desc: 'Built using coin api for keeping track of cryptocurrency market. Sorting with market price(high and low) , Pagination , Searching and also Deletion of coins has been implemented . One can add coins to watchlist and also can view statistics with charts/graphs of any coin just by clicking on the row items. Its both web and mobile responsive.',
				technologies: 'ReactJs, ChartJs, Javascript, Hooks, ContextApi, CSS3, Material-ui',
				site: 'https://crypto-contextapi.netlify.app/',
			},

			{
				img: process.env.PUBLIC_URL + '/assets/nat.png',

				imgPlaceholder: process.env.PUBLIC_URL + '/assets/nat.png',
				
				projectName: 'ReactNative-TravelUI',
				desc: 'Standalone Native application built for Android and ios devices, representing a very smoooth UI for travel app which can be customized later with added functionalities. You have to download the apk and install it on your device to view the app.',
				technologies: 'ReactNative, Expo, React-Navigation',
				site: 'https://drive.google.com/file/d/1GpA5csWk8e0u59ui9sQXjBoqMpRzvG4O/view?usp=sharing',
			},

		

			{
				img: process.env.PUBLIC_URL + '/assets/Capture3-removebg-preview.png',

				imgPlaceholder:  process.env.PUBLIC_URL + '/assets/Capture3-removebg-preview.png',
					
				projectName: 'ContextApi-TaskManager',
				desc: 'Simple task manager just to show case contextapi usage. One can install it and use it as their very own task manager, one can add, delete or edit task items. Its a standalone application which works in offline mode as well. PWA has been implemented. Its both web and mobile responsive. ',
				technologies: 'ReactJs, Javascript, ContextApi, Hooks, TailwindCss',
				site: 'https://reactcontextapi-task-manager.netlify.app/',
			},
		],
	},
	stack: {
		title: 'Stacks',
		tech: [
			{
				img: process.env.PUBLIC_URL + '/logo512.png',
				alt: 'react',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/javascriptlogo.jpg',
				alt: 'js',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/next.png',
				alt: 'next',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/htmlpic.png',
				alt: 'html',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/css3logo.jpg',
				alt: 'css',
			},

			{
				img: process.env.PUBLIC_URL + '/assets/tail.png',
				alt: 'tail',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/boot.png',
				alt: 'boot',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/fire.png',
				alt: 'firebase',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/mysl.png',
				alt: 'mysql',
			},
			{
				img: process.env.PUBLIC_URL + '/assets/mongo.png',
				alt: 'mongo',
			},
		],
		desc: `Apart from the above mentioned technologies, i am partially interested in Big data and Machine Learning as well. `,
	},
	contact: {
		title: 'About Me!',
		desc: "I love technology and i like to tinker around every new technologies that i come accross or crossed path with . I'm most attracted to solving real customer problems with a business justification . Currently, i am working as a Software Engineer in a Product-Based company at Bengaluru. ",
		socials: [
			{
				alt: 'github',
				img: process.env.PUBLIC_URL + '/assets/github.png',
			},
			{
				alt: 'link',
				img: process.env.PUBLIC_URL + '/assets/link.png',
			},
			{
				alt: 'gmail',
				img: process.env.PUBLIC_URL + '/assets/gmail.png',
			},
		],
		img: process.env.PUBLIC_URL + '/assets/pic-removebg-preview.png',
		imgPlaceholder:  process.env.PUBLIC_URL + '/assets/pic-removebg-preview.png',
		
	},
	extra: {
		// title: 'Ping Me!',
		// desc: "I love technology and i like to tinker around every new technologies that i come accross or crossed path with . I'm most attracted to solving real customer problems with a business justification . Currently, i am working as a Software Engineer in a Product-Based company at Bengaluru. ",
		extras: [
			{
				desc: 'Created a smart cap for visually impaired citizens that will immensely help them to detect obstacles uptil a certain height and diameter which can prevent various accidents beforehand.',
				tech: 'Technologies - Arduino Programming',
				title: 'Smart Cap',
			},
			{
				desc: 'The module that i have worked on is Analysis and Visualization of Malware Dataset, which was a part of a live ongoing project -Scalable attack data capturing and analysis framework for cyber threat intelligence generation. Also i successfully discovered several meaningful insights using Tableau from the dataset.',
				tech: 'Technologies - Big-Data, Hadoop, Sqoop, Tableau, MySQL, HiveQL',
				title: 'Big Data Project',
			},
			{
				desc: 'Predicted health status and disease prediction using Machine Learning and Deep Learning for a live ongoing project CATCH SIKKIM. Combined the model into a web application using Djano framework for seamless user interactivity.',
				tech: 'Technologies - Machine-Learning, Deep-Learning, Tensorflow, Keras, Django',

				title: 'ML/DL Project',
			},
			{
				desc: 'An application developed specially for all the faculty members of campus, through which they can book seats in the local campus bus beforehand, as they may sometimes miss the bus.',
				tech: 'Technologies - HTML5, CSS5, Javascript, Bootstrap, Php, MySQL',
				title: 'Online Bus Booking',
			},
			{
				desc: 'Developed a software interface for performing various operations on Gene Sequence. Basically the application extracts gene information from a valid fasta file.',
				tech: 'Technologies - HTML5, CSS3, Javascript, Bootstrap, Python, MongoDB',
				title: 'Genome-Extraction',
			},
		],
	},
};
